export interface AppState {
  score: number;
  highScore: number;
  combo: number;
  stage: number;
  isGameOver: boolean;
  /** Number of blocks remaining (excluding daruma head) */
  blocksRemaining: number;
  /** Number of X shares used this session */
  sharesUsed: number;
  /** Timestamp when the current stage started */
  stageStartTime: number;
  /** Last swipe speed (px/ms) for score calculation */
  lastSwipeSpeed: number;
}

export function createInitialState(): AppState {
  return {
    score: 0,
    highScore: 0,
    combo: 0,
    stage: 1,
    isGameOver: false,
    blocksRemaining: 5,
    sharesUsed: 0,
    stageStartTime: 0,
    lastSwipeSpeed: 0,
  };
}
